var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "Group 11" } }, [
        _c("g", { attrs: { id: "meeting 1" } }, [
          _c("g", { attrs: { id: "Group" } }, [
            _c("g", { attrs: { id: "Group_2" } }, [
              _c("path", {
                attrs: {
                  id: "Vector",
                  d: "M14.9219 13.125V14.6875C13.7553 14.6875 6.27473 14.6875 5.07812 14.6875V13.125H14.9219Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_2",
                  d: "M19.6094 0.390625V3.75H18.0469L17.2656 4.53125L16.4844 3.75H10.7812L10 4.53125L9.21875 3.75H3.51562L2.73437 4.53125L1.95312 3.75H0.390625V0.390625H19.6094Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_3",
                  d: "M14.9219 14.6875V16.25H13.125V19.6094H11.5625V15.4687C11.5625 15.0371 11.9121 14.6875 12.3438 14.6875H14.9219Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_4",
                  d: "M8.4375 15.4687V19.6094H6.875V16.25H5.07812V14.6875H7.65625C8.08789 14.6875 8.4375 15.0371 8.4375 15.4687Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_5",
                  d: "M10.7813 9.21875H9.21875C7.92422 9.21875 6.875 10.268 6.875 11.5625L8.4375 13.125H11.5625L13.125 11.5625C13.125 10.268 12.0758 9.21875 10.7813 9.21875Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_6",
                  d: "M6.875 11.5625C7.73789 11.5625 8.4375 12.2621 8.4375 13.125H5.07812V11.5625H6.875Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_7",
                  d: "M14.9219 11.5625V13.125H11.5625C11.5625 12.2621 12.2621 11.5625 13.125 11.5625H14.9219Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_8",
                  d: "M19.6094 11.5625V16.25C19.0423 16.25 15.4927 16.25 14.9219 16.25C14.9219 15.754 14.9219 12.0496 14.9219 11.5625C14.9219 10.268 15.9711 9.21875 17.2656 9.21875C18.5602 9.21875 19.6094 10.268 19.6094 11.5625Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_9",
                  d: "M5.07812 16.25C4.51102 16.25 0.961484 16.25 0.390625 16.25V11.5625C0.390625 10.268 1.43984 9.21875 2.73438 9.21875C4.02891 9.21875 5.07812 10.268 5.07812 11.5625V16.25Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("g", { attrs: { id: "Group_3" } }, [
                _c("path", {
                  attrs: {
                    id: "Vector_10",
                    d: "M17.2656 8.4375C18.1286 8.4375 18.8281 7.73795 18.8281 6.875C18.8281 6.01206 18.1286 5.3125 17.2656 5.3125C16.4027 5.3125 15.7031 6.01206 15.7031 6.875C15.7031 7.73795 16.4027 8.4375 17.2656 8.4375Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Vector_11",
                    d: "M10 8.4375C10.8629 8.4375 11.5625 7.73795 11.5625 6.875C11.5625 6.01206 10.8629 5.3125 10 5.3125C9.13706 5.3125 8.4375 6.01206 8.4375 6.875C8.4375 7.73795 9.13706 8.4375 10 8.4375Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Vector_12",
                    d: "M2.73438 8.4375C3.59732 8.4375 4.29688 7.73795 4.29688 6.875C4.29688 6.01206 3.59732 5.3125 2.73438 5.3125C1.87143 5.3125 1.17188 6.01206 1.17188 6.875C1.17188 7.73795 1.87143 8.4375 2.73438 8.4375Z",
                    fill: "white",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "Group_4" } }, [
              _c("path", {
                attrs: {
                  id: "Vector_13",
                  d: "M4.6875 6.875C4.6875 5.79805 3.81133 4.92188 2.73437 4.92188C1.65742 4.92188 0.78125 5.79805 0.78125 6.875C0.78125 7.95195 1.65742 8.82812 2.73437 8.82812C3.81133 8.82812 4.6875 7.95195 4.6875 6.875ZM2.73437 8.04688C2.0882 8.04688 1.5625 7.52117 1.5625 6.875C1.5625 6.22883 2.0882 5.70312 2.73437 5.70312C3.38055 5.70312 3.90625 6.22883 3.90625 6.875C3.90625 7.52117 3.38055 8.04688 2.73437 8.04688Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_14",
                  d: "M11.9531 6.875C11.9531 5.79805 11.077 4.92188 10 4.92188C8.92305 4.92188 8.04688 5.79805 8.04688 6.875C8.04688 7.95195 8.92305 8.82812 10 8.82812C11.077 8.82812 11.9531 7.95195 11.9531 6.875ZM10 8.04688C9.35383 8.04688 8.82812 7.52117 8.82812 6.875C8.82812 6.22883 9.35383 5.70312 10 5.70312C10.6462 5.70312 11.1719 6.22883 11.1719 6.875C11.1719 7.52117 10.6462 8.04688 10 8.04688Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_15",
                  d: "M14.5596 11.1719H13.4873C13.2971 9.84859 12.1563 8.82812 10.7813 8.82812H9.2188C7.84373 8.82812 6.70294 9.84859 6.51279 11.1719H5.44048C5.25033 9.84855 4.10955 8.82812 2.73447 8.82812C1.22669 8.82812 9.15527e-05 10.0547 9.15527e-05 11.5625V16.25C9.15527e-05 16.4657 0.175013 16.6406 0.390717 16.6406H2.34384V19.2188H1.17189C0.956185 19.2188 0.781263 19.3937 0.781263 19.6094C0.781263 19.8251 0.956185 20 1.17189 20H4.29689C4.51259 20 4.68751 19.8251 4.68751 19.6094C4.68751 19.3937 4.51259 19.2188 4.29689 19.2188H3.12501V16.6406H6.48439V19.6094C6.48439 19.8251 6.65931 20 6.87501 20H8.43751C8.65322 20 8.82814 19.8251 8.82814 19.6094V15.4688C8.82814 15.3318 8.80431 15.2004 8.76095 15.0781H9.60939V19.6094C9.60939 19.8251 9.78431 20 10 20C10.2157 20 10.3906 19.8251 10.3906 19.6094V15.0777H11.2391C11.1957 15.2004 11.1719 15.3318 11.1719 15.4688V19.6094C11.1719 19.8251 11.3468 20 11.5625 20H13.125C13.3407 20 13.5156 19.8251 13.5156 19.6094V16.6406H16.875V19.2188H15.7031C15.4874 19.2188 15.3125 19.3937 15.3125 19.6094C15.3125 19.8251 15.4874 20 15.7031 20H18.8281C19.0438 20 19.2188 19.8251 19.2188 19.6094C19.2188 19.3937 19.0438 19.2188 18.8281 19.2188H17.6563V16.6406H19.6094C19.8251 16.6406 20 16.4657 20 16.25V11.5625C20 10.0547 18.7734 8.82812 17.2656 8.82812C15.8905 8.82812 14.7498 9.84855 14.5596 11.1719ZM5.46876 14.2969V13.5156H14.5313V14.2969C12.9085 14.2969 7.85771 14.2969 5.46876 14.2969ZM6.87501 11.9531C7.38427 11.9531 7.81873 12.2796 7.97994 12.7344H5.46876V11.9531H6.87501ZM13.125 11.9531H14.5313V12.7344H12.0201C12.1813 12.2796 12.6158 11.9531 13.125 11.9531ZM9.21876 9.60938H10.7813C11.7407 9.60938 12.5402 10.305 12.7034 11.2182C11.954 11.3838 11.3648 11.9807 11.2112 12.7344H8.78884C8.63521 11.9806 8.04603 11.3838 7.29666 11.2182C7.45982 10.305 8.25931 9.60938 9.21876 9.60938ZM0.781263 11.5625C0.781263 10.4855 1.65744 9.60938 2.73439 9.60938C3.81134 9.60938 4.68751 10.4855 4.68751 11.5625V15.8594H0.781263V11.5625ZM8.04689 15.4688V19.2188H7.26564V16.25C7.26564 16.0343 7.09072 15.8594 6.87501 15.8594H5.46876V15.0781H7.65626C7.87165 15.0781 8.04689 15.2534 8.04689 15.4688ZM13.125 15.8594C12.9093 15.8594 12.7344 16.0343 12.7344 16.25V19.2188H11.9531V15.4688C11.9531 15.2534 12.1284 15.0781 12.3438 15.0781H14.5313V15.8594H13.125ZM17.2656 9.60938C18.3426 9.60938 19.2188 10.4855 19.2188 11.5625V15.8594H15.3125C15.3125 15.4607 15.3125 12.1031 15.3125 11.5625C15.3125 10.4855 16.1887 9.60938 17.2656 9.60938Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_16",
                  d: "M15.3125 6.875C15.3125 7.95195 16.1887 8.82812 17.2656 8.82812C18.3426 8.82812 19.2188 7.95195 19.2188 6.875C19.2188 5.79805 18.3426 4.92188 17.2656 4.92188C16.1887 4.92188 15.3125 5.79805 15.3125 6.875ZM17.2656 5.70312C17.9118 5.70312 18.4375 6.22883 18.4375 6.875C18.4375 7.52117 17.9118 8.04688 17.2656 8.04688C16.6195 8.04688 16.0938 7.52117 16.0938 6.875C16.0938 6.22883 16.6195 5.70312 17.2656 5.70312Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_17",
                  d: "M19.6094 0H11.7578C11.5421 0 11.3672 0.174922 11.3672 0.390625C11.3672 0.606328 11.5421 0.78125 11.7578 0.78125H19.2188V3.35938H18.0469C17.9433 3.35938 17.8439 3.40055 17.7707 3.47379L17.2656 3.97879L16.7606 3.47375C16.6873 3.40055 16.588 3.35938 16.4844 3.35938H10.7812C10.6777 3.35938 10.5783 3.40055 10.505 3.47379L10 3.97879L9.49496 3.47375C9.42168 3.40055 9.32234 3.35938 9.21875 3.35938H3.51562C3.41203 3.35938 3.3127 3.40055 3.23941 3.47379L2.73438 3.97879L2.22934 3.47379C2.15605 3.40055 2.05672 3.35938 1.95312 3.35938H0.78125V0.78125H8.24219C8.45789 0.78125 8.63281 0.606328 8.63281 0.390625C8.63281 0.174922 8.45789 0 8.24219 0H0.390625C0.174922 0 0 0.174922 0 0.390625V3.75C0 3.9657 0.174922 4.14062 0.390625 4.14062H1.79129L2.45813 4.80746C2.6107 4.95996 2.85797 4.95996 3.01059 4.80746L3.67746 4.14062H9.05695L9.72379 4.80746C9.87637 4.95996 10.1236 4.95996 10.2762 4.80746L10.9431 4.14062H16.3226L16.9894 4.80746C17.0657 4.88371 17.1656 4.92188 17.2656 4.92188C17.3656 4.92188 17.4655 4.88371 17.5418 4.80746L18.2087 4.14062H19.6094C19.8251 4.14062 20 3.9657 20 3.75V0.390625C20 0.174922 19.8251 0 19.6094 0Z",
                  fill: "white",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Vector_18",
                  d: "M10 0.78125C10.2158 0.78125 10.3907 0.606361 10.3907 0.390625C10.3907 0.174889 10.2158 0 10 0C9.78429 0 9.60941 0.174889 9.60941 0.390625C9.60941 0.606361 9.78429 0.78125 10 0.78125Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }